import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const PlayIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill={fillColor || '#111112'} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7 13.1943L7 6.80278C7 6.01735 7.86395 5.5385 8.53 5.95478L13.6432 9.15054C14.2699 9.54221 14.2699 10.4549 13.6432 10.8465L8.53 14.0423C7.86395 14.4586 7 13.9797 7 13.1943Z"
        fill={fillColor || '#111112'}
      />
    </svg>
  );
};

export { PlayIcon };
